import React, { useState } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { updateAuthPassword } from '../../actions/auth'
import { getAuth } from 'firebase/auth'
import SHSForm from './shs-form'
import InputElement from './input'
import VerifyPassword from '../shared/forms/verify-password'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const mapStateToProps = (state) => {
    return {
        fireauth: getAuth(),
        user: state.user
    }
}

const ManageAuth = ({ dispatch, fireauth, user }) => {
    const [inEdit, setInEdit] = useState(false)
    const [allValid, setAllValid] = useState(false)

    const handleValidationChange = (isValid) => {
        setAllValid(isValid)
    }

    const successFX = () => {
        window.alert('Password updated successfully')
        setInEdit(false)
    }

    const submitFX = (formData, formId) => {
        dispatch(updateAuthPassword(fireauth, formData, formId))
    }

    const renderForm = () => {
        return (
            <>
                <hr/>
                <SHSForm submitFX={submitFX} successFX={successFX} buttonLabel="Update Password" buttonDisabled={!allValid} showCancel={true} cancelAction={() => setInEdit(false)}>
                    <InputElement
                        type="password"
                        label="Existing Password"
                        id="existingPassword" />
                    <VerifyPassword onValidationChange={handleValidationChange} />
                </SHSForm>
            </>
        )
    }

    const renderView = () => {
        return (
            <>
                <Link className="clickable-right" onClick={() => setInEdit(true)}>Update Password &nbsp; <FontAwesomeIcon icon="caret-down" /></Link>
            </>
        )
    }

    return (
        <div className="manage-auth flex-100">
            {inEdit ? renderForm() : renderView()}
        </div>
    )
}

export default connect(mapStateToProps)(ManageAuth)
